import React from "react";
import classes from "./DeadEnd.module.css";
const DeadEnd = ({ heading, subText, backToStart }) => {
  return (
    <div className={classes.deadEndContainer}>
      <span className={classes.heading}>{heading}</span>
      <span className={classes.subText}>{subText}</span>
      <button onClick={backToStart} className={classes.backToStart}>
        <span style={{ color: "#f21ce3", fontSize: "1.5rem" }}>&#x3c;</span>
        <span>Back to start</span>
      </button>
    </div>
  );
};

export default DeadEnd;
